import React from "react";

export default function FILTVMerchantBadge({ ad }) {
    if (!ad) return null;

    return (
        <div className="absolute bottom-2 left-2 bg-black/70 backdrop-blur rounded-lg border border-zinc-700 px-2.5 py-1.5 max-w-[65%] sm:max-w-[180px]">
            <div className="text-xs sm:text-sm font-semibold text-white truncate">
                {ad.merchant}
            </div>
            {ad.city && (
                <div className="text-[10px] text-zinc-400 truncate">
                    {ad.area ? `${ad.area}, ` : ""}
                    {ad.city}
                </div>
            )}
        </div>
    );
}
